/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import { VacancyGroupStatusDropdown } from 'domain/recruiting/recruitingBoard/shared';

const VacancyGroupStatusFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <VacancyGroupStatusDropdown />
    </DropDownFilter>
  );
};

export default VacancyGroupStatusFilter;
